module.exports = __webpack_public_path__ + "img/symbol_14.2101849c.png";